<template>
	<div>
		<button class="btn btn-secondary btn-sm w-100 text-left" @click="selfExcludeModal = true">
			{{t('user.page.link.selfexclusion')}}
		</button>
		<modal v-if="selfExcludeModal" @close="selfExcludeModal = false">
			<div slot="body" >
				<form-message :messages="getMessage('self-exclude')"></form-message>
				<div class="text-center" v-html="t('popup.selfexclude.content')">

				</div>
			</div>
			<div class="row justify-content-center" slot="footer">
				<div class="col-6 col-lg-3 d-flex justify-content-center">
					<button @click="selfExcludeModal = false" class="btn btn-secondary">
						{{ t('popup.selfexclude.btn.cancel')}}
					</button>
				</div>
				<div class="col-6 col-lg-3 d-flex justify-content-center">
					<button class="btn btn-primary btn-sm" @click="submitSelfExclude">
						{{ t('popup.selfexclude.btn.submit')}}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>

	import Modal from '@/components/parts/modal';
	import FormMessage from '@/components/parts/form-message';

	export default {
		name: 'self-exclude',
		components:{
			'modal': Modal,
			'form-message': FormMessage
		},
		data() {
			return {
				selfExcludeModal: false
			}
		},
		computed:{

		},
		mounted(){
			this.deleteMessage('self-exclude');
		},
		methods: {
			submitSelfExclude(){
				this.deleteMessage('self-exclude');
				this.$store.dispatch('requestSelfExlude').then((response)=>{
					if(response.data.status === 'SUCCESS'){
						this.$router.push({name: 'Logout'});
					}

					this.restMessageHandler(response.data.status, 'self-exclude', response.data.error, 'self-exclude')

				});
			}
		}
	}
</script>